import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { loadReportPZ04ByIdRequest } from '../../../redux/reportsPZ04Redux';
import DetailPZ04Form from '../../common/DetailPZ04Form/DetailPZ04Form';

const DetailsPZ04 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [report, setReport] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const start = async () => {
      const res = await dispatch(loadReportPZ04ByIdRequest(id));
      if (res) {
        setReport(res.data);
        setLoading(false);
      } else {
        navigate('/pz04');
      }
    };
    start();
  }, [dispatch]);

  if (!loading) {
    return <DetailPZ04Form props={report} />;
  }
};

export default DetailsPZ04;
